import { ContractStatus } from "../types";

const STYLES: Record<ContractStatus | "PENDING", string> = {
  ACTIVE: "bg-[#E2F4EB] text-[#0A8F4F]",
  INACTIVE: "bg-[#ECEEF3] text-[#6B6877]",
  PENDING: "bg-[#FFF4D6] text-[#B68A0E]",
};

export function StatusBadge({
  status,
}: {
  status: ContractStatus | "PENDING";
}) {
  return (
    <span
      className={`text-[10px] font-semibold tracking-wider px-1.5 py-[2px] rounded-lg ${STYLES[status]}`}
    >
      {status}
    </span>
  );
}

export default StatusBadge;
